import React, { useState, useReducer } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import dayjs from "dayjs";
import StepLabel from "@mui/material/StepLabel";
import AlarmStep from "./AlarmStep";
import AccountNumberStep from "./AccountNumberStep";
import { get } from "aws-amplify/api";
import { I18n } from "aws-amplify/utils";
import currentUserToken from "CurrentUserToken";
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

function StepperAlarmDialog(props) {
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });

  const [disableBackButton, setDisableBackButton] = useState(false);
  const [selectedAccountNumber, setSelectedAccountNumber] = useState(null);
  const steps = [I18n.get("Find Account Number"), I18n.get("Submit Alarm")];

  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    source_flow: "Manual",
    source_technology: "Manual",
    original_technology: "Manual",
    original_priority: 1,
    original_equipment: null,
    datetime_end: null,
    position: null,
    account_number: "",
  });

  const fetchAccountNumbers = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/accountNumber/get",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleCreateAlarm = () => {
    props.handleCreateAlarm(formData);
  };

  const handleMainFormData = (field, value) => {
    setFormData((currentState) => ({
      ...currentState,
      [field]: value,
    }));
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
      maxWidth="xl"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle style={{cursor: 'move'}}>{I18n.get("Submit an Alarm")}</DialogTitle>
      <DialogContent>
        <Stepper activeStep={currentStep}>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {currentStep === 0 && (
          <AccountNumberStep
            fetchData={fetchAccountNumbers}
            handleMainFormData={handleMainFormData}
            state={state}
            selectedAccountNumber={selectedAccountNumber}
            setSelectedAccountNumber={setSelectedAccountNumber}
            mainFormData={formData}
          />
        )}
        {currentStep === 1 && (
          <AlarmStep
            handleMainFormData={handleMainFormData}
            mainFormData={formData}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ pt: 2 }} style={{cursor: 'move'}}>
        {currentStep > 0 && (
          <Button
            color="primary"
            disabled={disableBackButton}
            onClick={handleBack}
          >
            {I18n.get("Back")}
          </Button>
        )}
        {currentStep === 0 && (
          <>
            <Button
              type="button"
              color="primary"
              onClick={() => props.onClose()}
              style={{ marginLeft: "10px" }}
            >
              {I18n.get("Cancel")}
            </Button>
            <Button
              color="primary"
              onClick={handleNext}
              disabled={!formData.account_number}
            >
              {I18n.get("Next")}
            </Button>
          </>
        )}
        {currentStep === 1 && (
          <>
            <Button
              color="primary"
              onClick={() => props.onClose()}
              style={{ marginLeft: "10px" }}
            >
              {I18n.get("Cancel")}
            </Button>
            <Button
              color="primary"
              onClick={handleCreateAlarm}  
              disabled={
                !formData.original_message ||
                formData.original_message === null ||
                !formData.account_number ||
                formData.account_number === null ||
                !formData.original_equipment ||
                formData.original_equipment === null
              }
            >
              {I18n.get("Submit")}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default StepperAlarmDialog;
